export default __webpack_public_path__ + "static/media/CV.75fbeb18.svg";